<template>
  <div class="survey-main">
    <div id="survey-form">
      <h1 class="center-it bold"></h1>
      <span class="center-it"><h1>FeedbackBot</h1></span>
       <div class="chat-container">
          <div class="chat-window" id="chatWindow" ref="chatWindow">
              <b class="blue">FeedbackBot:</b> Hi, how was your experience? <br>
              <span v-html="responseText"></span>
          </div>
          <div class="chat-input-container">
            <input v-model="prompt" type="text" id="chatInput" placeholder="Type a message...">
            <!-- <button id="submitBtn">Submit</button> -->
            <button
              type="button"
              class="chat-input-container"
              @click="getResponse"
            >
              Send
            </button>
          </div>
      </div><br>
      <span class="center-it">
        <div v-if="name === 'MASTEK'" id="logo" class="center-element center-text">
          <img
            src="../assets/mastek_small@2x.png"
            srcset="
            ../assets/mastek_small@1x.png 1x,
            ../assets/mastek_small@2x.png 2x
          "
          />
        </div>
        <div v-else id="logo" class="center-element center-text">
          <img
            src="../assets/machinecore_logo_final@2x.png"
            srcset="
            ../assets/machinecore_logo_final@1x.png 1x,
            ../assets/machinecore_logo_final@2x.png 2x
          "
          />
        </div>
        
        <br/><a href="#" @click.prevent="logout">Logout</a> 
      </span>
      <br />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {
      prompt: "",
      responseText: "",
      apiToken: this.$route.params.token,
      VUE_APP_BOT_API: process.env.VUE_APP_BOT_API || "http://localhost:8000",
      name: process.env.VUE_APP_FACE
    };
  },
  created() {
    console.log(this.apiToken)
  },
  methods: {
    getResponse: async function () {
      try {
        if (this.prompt === "") {
          return;
        }
        const response = await fetch(`${this.VUE_APP_BOT_API}/chat?token=${this.apiToken}&message=${this.prompt}`, {
          credentials: "include",
          mode: "cors",
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        this.responseText += '<div class="user_dialog"><b>User:</b> ' + this.prompt + '</div><b class="blue">SurveyBot:</b>  ';
        this.scrollToBottom();
        this.prompt = "";
        const reader = response.body.getReader();
        /* eslint-disable no-constant-condition */
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          const chunk = new TextDecoder().decode(value);
          console.log(chunk)
          this.responseText += chunk;
          this.scrollToBottom();
        }
        this.responseText += '<br />';
        // Close the reader
        reader.releaseLock();
      } catch (error) {
        console.error("Error fetching response:", error);
        // Handle errors, perhaps setting some error state or notifying the user
      }
    },
    logout: async function () {
      try {
        const response = await fetch(`${this.VUE_APP_BOT_API}/logout`, {
          credentials: "include",
          mode: "cors",
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        this.responseText = "";
        this.prompt = "";
      } catch (error) {
        console.error("Error fetching response:", error);
        // Handle errors, perhaps setting some error state or notifying the user
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const chatWindow = this.$refs.chatWindow;
        chatWindow.scrollTop = chatWindow.scrollHeight;
      });
    }
  },
};
</script>
<style>

body, html {
    height: 100%;
    margin: 0;
    font-family: Arial, sans-serif;
    background: #fafafa;
}
.center-it {
  display: block;
  text-align: center;
}
#survey-form {
  margin: 60px auto 0 auto;
  padding: 20px;
  width: 70%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #cfe1f6;
}
.chat-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 10px;
}

.chat-window {
    flex-grow: 1;
    overflow-y: auto;
    height: 300px;
    border: 1px solid #ccc;
    padding: 10px;
    margin-bottom: 10px;
}

.chat-input-container {
    display: flex;
    justify-content: space-between;
    align-items: center;  /* Vertically centers the child elements */
}

.chat-input-container input {
    width: 75%;
    padding: 10px;
    height: 50px; /* Set the height of the input to match the button */
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box; /* Include padding and border in the element's total width and height */
    font-size: 16px;
    font-weight: normal;
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

.chat-input-container button {
    width: 25%;
    padding: 10px;
    height: 50px;
    margin-left: 2px;
    background-color: #007BFF;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box; /* Include padding and border in the element's total width and height */
}

.chat-input-container button:hover {
    background-color: #0056b3;
}

.user-message {
    background-color: #f1f1f1;
    padding: 10px;
    border-radius: 5px;
    margin: 5px 0;
}

.user_dialog {  
  padding:8px 0;
}
.blue {
  color: #0c4f96;
}



</style>
